export enum IntegrationSyncType {
  Customers = 'customers',
  Locations = 'locations',
  Products = 'products',
  Salespeople = 'salespeople',
  Transactions = 'transactions',
}
